import { assert } from '@varos/util-typescript';
import { ChatLoaderBaseConfig } from '../../../base';
import { CallRequestNewLoader } from './callRequestNewInterface';
import { CallRequestNewAggregate } from './callRequestNewModel';
import { useMemo } from 'react';
import { CallAggregate } from '@varos/call-core';
import { AssistantContext } from '@varos/assistant-react';
import { ThreadDetailAggregate } from '../../../thread';
import { MessageItemAggregate } from '../../../message';

export function createCallRequestNewLoader(
    config: ChatLoaderBaseConfig
): CallRequestNewLoader {
    const { repository } = config;
    return {
        useLoad(context, props): CallRequestNewAggregate {
            const integrationQuery = repository.platform.integration.useRetrieve(
                context,
                props.integration.id,
                {
                    suspense: true,
                }
            );
            assert(integrationQuery.status === 'success', 'expected suspense');

            const definitionQuery = repository.platform.integrationDefinition.useRetrieve(
                context,
                integrationQuery.data.definition_id,
                {
                    suspense: true,
                }
            );
            assert(definitionQuery.status === 'success', 'expected suspense');

            // Load messages for this thread
            const messagesQuery = repository.assistant.local.message.useFind(
                context as AssistantContext,
                { thread: props.thread.id, limit: 25 },
                {
                    suspense: true,
                    staleTime: 0,
                    refetchOnMount: true,
                    refetchOnWindowFocus: true,
                    refetchOnReconnect: true,
                }
            );
            assert(messagesQuery.status === 'success', 'expected suspense for messages');

            // const call = useMemo((): CallAggregate => {
            //     return {
            //         context: {
            //             transcript: messagesQuery.data.flatMap((item) => {
            //                 const parts = item.parts.flatMap((part) =>
            //                     part.type === 'text' ? [part.text] : []
            //                 );
            //                 if (parts.length === 0) {
            //                     return [];
            //                 }
            //                 return [
            //                     {
            //                         role:
            //                             item.role === 'system' ? 'assistant' : item.role,
            //                         text: parts.join('\n'),
            //                     },
            //                 ];
            //             }),
            //             configuration: {
            //                 interviewer: {
            //                     name: definitionQuery.data.display_name,
            //                     description: definitionQuery.data.description,
            //                 },
            //                 purpose: props.tool.args.purpose,
            //                 context: props.tool.args.context,
            //             },
            //             dump: {
            //                 ...props.tool.args,
            //             },
            //         },
            //     };
            // }, [messagesQuery.data, definitionQuery.data, props.tool.args]);

            const thread = useMemo((): ThreadDetailAggregate => {
                return {
                    thread: props.thread,
                    messages: messagesQuery.data.map(
                        (msg): MessageItemAggregate => ({
                            definition: definitionQuery.data,
                            instance: integrationQuery.data,
                            message: msg,
                        })
                    ),
                    integration: integrationQuery.data,
                    definition: definitionQuery.data,
                };
            }, [messagesQuery.data, integrationQuery.data, definitionQuery.data]);

            return {
                integration: integrationQuery.data,
                definition: definitionQuery.data,
                thread,
                // tool: props.tool,
                // call,
            };
        },
    };
}
